module.exports = __webpack_public_path__ + "static/media/bellhop_movers.8386d166.svg";